<template>
    <div class="date-time-box">
        <div class="top">
            <span class="required" v-if="required">*</span>
            <div class="title" v-html="title"></div>
        </div>
        <div class="input" @click="openDataTimePopup"> {{ value ? value : placeholder }}</div>
        <DataTimePopup :minDate="minDate" :maxDate="maxDate" :filterFormat="filterMinute" :show="showPopup" :dateTime="value"  @cancel="showPopup = false" @confirmTime="confirmTime"/>
    </div>
</template>
<script>
    import DataTimePopup from '../../DateTimeLimit/DateTimeLimit.vue'
    import moment from 'moment'
    const Year = moment().get('y');
    export default {
        name: 'DateTime',
        props: {
            value: String,
            title:String,
            required:Boolean,
            placeholder:{
                type: String,
                default:''
            },
            isDetails:{
                type:Boolean,
                default:false
            }
        },
        data:function(){
            return {
                showPopup:false,
                minDate:new Date(Year + '-01-01'),
                maxDate:new Date(Year + '-12-31'),
            }
        },
        methods:{
            openDataTimePopup(){
                if(this.isDetails){return;}
                this.showPopup = true;
            },
            confirmTime(dateTime){
                this.$emit('input',dateTime);
                this.showPopup = false;
            },
            filterMinute(type, options) {
                // if (type === 'hour') {
                //     return options.filter(option => +option.substring(0, 2) >= 2 && + option.substring(0, 2) <= 22)
                // }
                if (type === 'minute') {
                    return options.filter(option => +option.substring(0, 2) % 10 === 0)
                }
                return options;
            }
        },
        mounted(){
            if(this.isDetails)return;
            //let now = moment("YYYY-MM-DD HH:mm");
            this.$emit('input',moment().format('YYYY-MM-DD HH:mm:ss'));
        },
        components:{DataTimePopup}
    }
</script>
<style lang="scss" scoped>
    .date-time-box{
        padding: 16px;
        .top{
            display: flex;
            align-items: center;
            margin-bottom: 16px;
            .required{
                color: #F84025;
                margin-right: 6px;
            }
            .title{
                color: #26292F;
                font-size: 16px;
            }
        }
        .input{
            width: 100%;
            height: 45px;
            font-size: 15px;
            padding: 0 16px;
            display: flex;
            align-items: center;
            color: #999;
            border:1px solid #D6D3D3;
        }
    }
</style>
